import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { TapestrySidenavService } from '@predictiveindex/tapestry';
import { SellerToolType } from '../../../core-data-model/seller-tools/seller-tool-type.model';
import { SellerToolsPeekData } from '../../../core-data-model/seller-tools/seller-tools-peek-panel-data.model';
import { FeatureFlags, FeatureFlagsService } from '../../../system-services';
import { TranslationService } from '../../../translations';

export const SELLER_TOOL_PEEK_DATA = InjectionToken<SellerToolsPeekData>;

@Component({
    selector: 'seller-tools-base',
    templateUrl: './seller-tools-base.component.html',
    styleUrls: ['./seller-tools-base.component.less'],
    standalone: false
})
export class SellerToolsBaseComponent implements OnInit {
    primaryFooterKey: string;
    sellerToolsTabs = [
        SellerToolType.OpenInvitation,
        SellerToolType.ProspectDemos,
        SellerToolType.WorkshopAccounts
    ];
    enableDemoAndWorkshopTabs = true;
    showDeleteFeature = false;
    activeTab: SellerToolType = this.sellerToolsTabs[0];

    protected readonly SellerToolType = SellerToolType;

    constructor(
        @Inject(SELLER_TOOL_PEEK_DATA)
        public sellerToolPeekData: SellerToolsPeekData,
        private TR: TranslationService,
        private sideNav: TapestrySidenavService,
        private flags: FeatureFlagsService
    ) {}

    ngOnInit(): void {
        this.activeTab = this.sellerToolPeekData.sellerToolType;
        if (this.flags.getByFlag(FeatureFlags.enableSellerToolsDelete)) {
            this.showDeleteFeature = true;
        }
        this.primaryFooterKey = this.TR.key(
            'seller-tools-panel.prospect-demos.tab.delete-button'
        );

        if (!this.flags.getByFlag(FeatureFlags.enableWorkshopAccess)) {
            this.enableDemoAndWorkshopTabs = false;
        }
    }

    closePeek() {
        this.sideNav.close();
    }

    handleTabChange(event) {
        this.activeTab = this.sellerToolsTabs[event.index];
        this.getPrimaryFooterKey();
    }

    getPrimaryFooterKey() {
        switch (this.activeTab) {
            case 'ProspectDemos':
                this.primaryFooterKey = this.TR.key(
                    'seller-tools-panel.prospect-demos.tab.delete-button'
                );
                break;
            case 'WorkshopAccounts':
                this.primaryFooterKey = this.TR.key(
                    'seller-tools-panel.workshop-accounts.tab.delete-button'
                );
                break;
            default:
                this.primaryFooterKey = this.TR.key('text.common-terms.save');
        }
    }
}
